import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const ImgRegion = styled.div`
  display: ${({ isBrokenImage }) => (isBrokenImage ? 'none' : 'inline-block')};
`;

class Image extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isBrokenImage: true,
    };
  }

  handleOnLoad = () => {
    this.setState({
      isBrokenImage: false,
    });
  };

  render() {
    const { isBrokenImage } = this.state;
    const { alt, src, renderFallback } = this.props;
    return (
      <>
        <ImgRegion isBrokenImage={isBrokenImage}>
          <img alt={alt} src={src} onLoad={this.handleOnLoad} />
        </ImgRegion>
        {isBrokenImage && renderFallback()}
      </>
    );
  }
}

Image.propTypes = {
  /**
   * Image Url
   */
  src: PropTypes.string.isRequired,
  /**
   * Alternate text for an image
   */
  alt: PropTypes.string,
  /**
   * Render prop fallback (only rendered if src url fails)
   */
  renderFallback: PropTypes.func,
};
Image.defaultProps = {
  alt: '',
  renderFallback: () => {},
};

export default Image;
